import Code from '@primer/gatsby-theme-doctocat/src/components/code';
import * as React from 'react';
export default {
  Code,
  React
};